import { Phone, MessageCircle } from "lucide-react";
import { COMPANY } from "../../lib/constants";

export const FloatingActions = () => {
  const waLink = `https://wa.me/${COMPANY.whatsapp.replace(/\D/g, "")}?text=${encodeURIComponent(
    "Hi M Brothers, I'd like a free cleaning quote."
  )}`;

  return (
    <div className="fixed right-4 bottom-4 sm:right-6 sm:bottom-6 z-40 flex flex-col gap-3">
      <a
        href={waLink}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="float-whatsapp"
        aria-label="Chat on WhatsApp"
        className="group relative w-14 h-14 rounded-full bg-gradient-to-br from-[#25D366] to-[#1EBE5D] text-white flex items-center justify-center shadow-glow-soft hover:shadow-glow-blue active:scale-95 transition-all"
      >
        <span className="absolute inset-0 rounded-full ring-1 ring-white/40" />
        <span className="absolute -inset-1 rounded-full bg-[#25D366]/40 blur-md animate-pulse" />
        <MessageCircle className="relative w-6 h-6" />
      </a>
      <a
        href={`tel:${COMPANY.phoneClean}`}
        data-testid="float-call"
        aria-label="Call now"
        className="group relative w-14 h-14 rounded-full bg-gradient-to-br from-blue-700 via-blue-600 to-sky-500 text-white flex items-center justify-center shadow-glow-blue active:scale-95 transition-all"
      >
        <span className="absolute inset-0 rounded-full ring-1 ring-white/40" />
        <Phone className="relative w-5 h-5" />
      </a>
    </div>
  );
};

export default FloatingActions;
